module.exports = __webpack_public_path__ + "img/two.c6ce4197.svg";